import { Button, Menu, PopoverProps } from '@mantine/core'

import { Icons } from 'src/common/components'

interface IMenuItem {
  label: string
  icon?: React.ReactElement
  onClick?: () => void
  color?: string
  enable: boolean
}

const ActionMenu = ({
  menuItems,
  ButtonIcon,
  menuPosition = 'bottom-end',
}: {
  menuItems: IMenuItem[]
  ButtonIcon?: React.ReactElement
  menuPosition?: PopoverProps['position']
}) => {
  const filteredItems = menuItems.filter(({ enable }) => enable)
  return (
    <Menu
      shadow="md"
      position={menuPosition}
      offset={1}
      styles={{ item: { fontWeight: 700, fontSize: '16px' } }}
    >
      <Menu.Target>
        <Button
          pr={0}
          variant="transparent"
          rightSection={ButtonIcon ? ButtonIcon : <Icons.DotsMenu />}
        />
      </Menu.Target>

      <Menu.Dropdown>
        {filteredItems.map(({ icon, label, color, onClick = () => {} }) => (
          <Menu.Item
            key={label}
            leftSection={icon}
            color={color}
            onClick={onClick}
          >
            {label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default ActionMenu
